import React, { useContext } from 'react';
import colors from 'styles/colors';
import sizes from 'styles/sizes';
import styled from 'styled-components';

import { url } from 'components/Footer/constants';

import { CruiseSearchContext } from 'contexts/CruiseSearchContext';

const TextContainer = styled.span`
  margin-right: 8px;
  text-transform: uppercase;
`;

const ToolBarContainer = styled.div`
  align-items: center;
  color: ${colors.primary.ice};
  display: flex;
  font-size: 12px;
  height: 24px;
  justify-content: flex-end;
  letter-spacing: 2px;
  margin: 0 ${sizes.gutter.large}px;
`;
const CountrySelect = styled.a`
  margin-right: 25px;

  & span {
    margin-left: 10px;
  }
`;

const ContactPhone = styled.a``;

export const LogoFlag = styled.img`
  height: 9px;
  width: 12px;
`;

/**
 * Renders the tool bar in header
 *
 */

const ToolBar = () => {
  const { locale } = useContext(CruiseSearchContext);

  const { nameCountry, country, phoneNumber } = locale || {};

  return (
    <ToolBarContainer>
      <CountrySelect href="/resources/select-location">
        <TextContainer>{nameCountry}</TextContainer>
        <LogoFlag
          className="flag"
          src={`${url}/content/dam/royal/resources/icons/flags/${country}.svg`}
          alt={country}
        />
      </CountrySelect>
      <ContactPhone href={`tel:${phoneNumber}`}>{phoneNumber}</ContactPhone>
    </ToolBarContainer>
  );
};

export default ToolBar;
